import React from 'react';
import {
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList
} from 'recharts';

const RevenueAreaChart = ({ data = [] }) => {
  return (
    <div className="rounded-2xl bg-white shadow-sm border border-gray-100 p-4 h-[360px]">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Revenue Over Time</h3>
      </div>
      <ResponsiveContainer width="100%" height="88%">
        <AreaChart data={data}>
          <defs>
            <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#16a34a" stopOpacity={0.35} />
              <stop offset="95%" stopColor="#16a34a" stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#f1f5f9" strokeDasharray="3 3" />
          <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#64748b' }} />
          <YAxis tick={{ fontSize: 11, fill: '#64748b' }} />
          <Tooltip />
          <Area type="monotone" dataKey="value" stroke="#16a34a" fill="url(#revenueGradient)" strokeWidth={2.5} animationDuration={700}>
            <LabelList dataKey="value" position="top" style={{ fill: '#065f46', fontSize: 10 }} />
          </Area>
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueAreaChart;
